/** Display labels aligned with backend `visitorStatusFormatter`. */
export const VISITOR_STATUS_LABELS = {
  INSIDE: "Inside",
  COMPLETED: "Completed",
  PENDING_EXIT: "Pending Exit",
};

export const VISITOR_STATUS_OPTIONS = [
  { value: VISITOR_STATUS_LABELS.INSIDE, label: VISITOR_STATUS_LABELS.INSIDE },
  { value: VISITOR_STATUS_LABELS.COMPLETED, label: VISITOR_STATUS_LABELS.COMPLETED },
  {
    value: VISITOR_STATUS_LABELS.PENDING_EXIT,
    label: VISITOR_STATUS_LABELS.PENDING_EXIT,
  },
];
